import React from "react";
import { euro } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { OperatorLogo } from "@/components/mobile/OperatorLogo";
import { CreditSpark } from "@/components/mobile/CreditHistory";

const when = (v) => (v ? new Date(v).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "");
const month = () => new Date().toLocaleDateString("it-IT", { month: "long" });

const Usage = ({ o }) => {
  const u = o.usage || {};
  return <span data-testid={`op-credit-usage-${o.key}`}>{u.attivazioni || 0} attivazioni · {u.ricariche || 0} ricariche · {u.cambi_promo || 0} cambi promo</span>;
};

export const OperatorCredits = ({ items }) => (
  <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="op-credits">
    {items.filter((o) => o.kind === "sim").map((o) => {
      const consumo = o.billing_mode === "consumo";
      return (
        <Card key={o.key} className="p-4 space-y-2" data-testid={`op-credit-${o.key}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div className="flex h-9 w-32 items-center justify-center rounded-lg bg-white px-2"><OperatorLogo op={o} className="max-h-7" /></div>
            <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${consumo ? "bg-sky-100 text-sky-700" : "bg-emerald-100 text-emerald-700"}`} data-testid={`op-credit-mode-${o.key}`}>{consumo ? "A consumo · fattura a fine mese" : "Credito prepagato"}</span>
          </div>
          {consumo
            ? <p className="text-sm">Movimentato a {month()}: <strong className="text-2xl block" data-testid={`op-credit-value-${o.key}`}>{euro(o.usage?.valore || 0)}</strong></p>
            : <p className="text-sm">Credito presso l'operatore: <strong className="text-2xl block" data-testid={`op-credit-value-${o.key}`}>{o.credit_balance == null ? "—" : euro(o.credit_balance)}</strong></p>}
          <p className="text-xs text-muted-foreground" data-testid={`op-credit-updated-${o.key}`}>
            {consumo ? <Usage o={o} /> : o.credit_balance == null ? "In attesa del primo aggiornamento dall'operatore" : `Aggiornato il ${when(o.credit_updated_at)} · ${o.credit_source === "operatore" ? "dall'operatore" : "a mano"}`}
          </p>
          {!consumo && <p className="text-xs text-muted-foreground">Questo mese: {euro(o.usage?.valore || 0)} movimentati · <Usage o={o} /></p>}
          {!consumo && <CreditSpark key={o.credit_updated_at || "none"} op={o} />}
        </Card>
      );
    })}
  </div>
);
